<template>

  <div class="demo-spin-article">

    <div v-if="displayTable">
      <Row class="box-table-header">
        <Col span="7" style="text-align: left">Наименование</Col>
        <Col span="4">Цена</Col>
        <Col span="4">Кол-во</Col>
        <Col span="5">Выручка</Col>
        <!--        <Col span="4">Рентабельность</Col>-->
        <Col span="4">Маржинальность</Col>
      </Row>

      <Row class="box-table-row" v-for="item in data">
        <Col span="7" style="text-align: left"> {{formatShortText(item.name)}}</Col>
        <Col span="4">{{formatNumber(item.average_price)}} {{ $store.state.currency }}</Col>
        <Col span="4">{{formatNumber(item.total_count)}}</Col>
        <Col span="5">{{formatNumber(item.total_sum)}} {{ $store.state.currency }}</Col>
        <!--        <Col span="4">{{formatNumber(item.profitability)}} %</Col>-->
        <Col span="4">{{formatNumber(item.marginality)}} %</Col>
      </Row>
    </div>
    <div v-else class="box-no-data">
      Нет данных для отображения
    </div>
  </div>

</template>

<script>
    import {formatShortText} from "../../base/base_func";
    import {base_url} from "../../http";

    import {formatNumber} from "../../base/base_func";



    export default {
        name: "topProductsTable",
        data() {
            return {
                loading: true,
                data: [],
                defaultFilter: "month"
            };
        },
        computed: {
            displayTable(){
                return this.data.length!==0
            }
        },
        // Загружаем данные для таблицы
        methods: {
            selectFilter: function (period) {
                // console.log(name);
                this.fetchData(period);
            },
            fetchData: function (period) {
                this.loading = true;
                this.lastDraw++;
                let url = `${base_url}/charts/top_products/?size=10`;
                this.$http
                    .get(url, {
                        params: {period: period}
                    })
                    .then(result => {
                        this.data = result.data;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            formatNumber(val) {
                return formatNumber(val);
            },

            formatShortText(text) {
                if (text.length > 20 ){
                    return text.slice(0, 20) + '...';
                }
                else
                    return text;

            },
        },
        mounted: function () {
            this.fetchData(this.defaultFilter);
        }
    };
</script>

<style scoped>
  .ivu-menu {
    z-index: 1;
  }
  .menu-item {
    font-size: 16px;
    line-height: 30px !important;
    padding: 0 5px !important;
  }
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active,
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:hover,
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu-active,
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu:hover {
    /*color: #2d8cf0;*/
    /*border-bottom: None;*/
    /*font-weight: bold;*/
    color: rgba(37, 215, 126, 1);
    border-bottom: unset;
  }
  .ivu-menu-horizontal.ivu-menu-light::after {
    background: white;
  }
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item,
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu {
    border-bottom: unset;
    /*color: #515a6e;*/
  }
  .ivu-menu-horizontal .ivu-menu-item,
  .ivu-menu-horizontal .ivu-menu-submenu {
    color: #8080809e;
    /*float: left;*/
    /*padding: 0 10px;*/
    /*position: relative;*/
    /*cursor: pointer;*/
    /*z-index: 3;*/
    /*transition: all 0.2s ease-in-out;*/
  }
  .box-table-header {
    font-size: 15px;
    text-align: center;
    margin: 30px 0 20px 0;
    color:grey;
  }
  .box-table-row {
    text-align: center;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.24);
    padding: 13px;
    border-radius: 20px;
    position: relative;
    font-size: 15px;
    margin: 20px 0;
    /*text-align: left;*/
  }

  .box-no-data {
    font-size: 20px;
    color: #80808094;
    width: 300px;
    margin: 80px auto 80px auto;
  }


  @media screen and (max-width: 1900px) {
    .box-table-row, .box-table-header {
      font-size: 14px;
    }
    .menu-item {
      font-size: 15px;
    }
  }

  @media screen and (max-width: 1500px) {
    .box-table-row, .box-table-header {
      font-size: 13px;
    }
    .menu-item {
      font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/apps/report/topProducts.vue